(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productV2JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productV2VariantJSON").textContent);
    let quantity = 1;

    // This is a bundle product. The selling plan is not
    // based on the base product, but separate product in the bundle
    // for example the selling plan would be for refills instead of the base product

    // find the bundle product that the subscription is based on
    let subscriptionProduct = JSON.parse(section.querySelector('.productV2SBundleBodyItem.sub').dataset.product);
    let subscriptionVariant = JSON.parse(section.querySelector('.productV2SBundleBodyItem.sub').dataset.variant);


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.productV2 = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productV2VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        navigation: {
            prevEl: section.querySelector(".productV2VisualThumbsPrev"),
            nextEl: section.querySelector(".productV2VisualThumbsNext"),
        },
        on: {
            slideChange: function () {
                if (!section.querySelector(".productV2VisualSwiperSlide")) {
                    return;
                }
                // update the thumbnail active class
                section.querySelector(".productV2VisualThumbsSlide.active").classList.remove("active");
                section.querySelectorAll(".productV2VisualThumbsSlide")[this.realIndex].classList.add("active");

                // pause all videos
                section.querySelectorAll(".productV2VisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productV2VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV2VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV2VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productV2VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    function attachOptionListeners() {

        // update active variant on input changes
        section.querySelectorAll("input, select").forEach(function (element) {
            element.addEventListener("change", function () {

                // if this is a gift/bundle, update the variant data first
                if (element.classList.contains('bundle')) {
                    let giftItem = element.closest('.productV2SBundleBodyItem');
                    let selectedOption = element.options[element.selectedIndex];

                    // update the variant data
                    giftItem.dataset.item = selectedOption.dataset.item;
                    giftItem.dataset.variant = selectedOption.value;
                    giftItem.dataset.quantity = selectedOption.dataset.quantity;
                }

                updateProduct();
            });
        })
    }

    // initially attach listeners to options
    attachOptionListeners();


    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productV2SellingLabelInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productV2SellingLabelBodyFrequencyBodyLabelInput:checked').value);
    }

    async function updateProduct() {
        // Find the active variant

        // default fallback
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV2OptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productV2ATC").classList.add('oos');
            section.querySelector(".productV2ATC").textContent = section.querySelector(".productV2ATC").dataset.sold
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }


        /**************
         Selling Plans
         ***************/

            // find the index of the previously selected selling plan
        let inputs = section.querySelectorAll(`.productV2SellingLabelBodyFrequencyBodyLabelInput`);
        let selectedInputIndex = 0;
        inputs.forEach((input, index) => {
            if (input.checked) {
                selectedInputIndex = index;
            }
        });

        let sellingPlanInputsHTML = "";

        // loop over every selling plan allocation for the subscription product
        // (not the base product since the selling plan is based on the subscription product in the bundle)
        // and create the selling plan inputs, checking the one that was previously selected
        subscriptionVariant.selling_plan_allocations.forEach((sellingPlanAllocation, index) => {
            // find the selling plan name since it's not in the object
            let sellingPlan = getSellingPlanById(subscriptionProduct, sellingPlanAllocation.selling_plan_id);
            let checked = index === selectedInputIndex ? 'checked' : '';

            sellingPlanInputsHTML += `
                <label class="productV2SellingLabelBodyFrequencyBodyLabel">
                    <input class="productV2SellingLabelBodyFrequencyBodyLabelInput" type="radio" name="${sectionID}-frequency"
                           value="${sellingPlan.id}"  ${checked}
                           data-frequency="${sellingPlan.name}">
                    <div class="productV2SellingLabelBodyFrequencyBodyLabelBody">
                        <div class="productV2SellingLabelBodyFrequencyBodyLabelBodyCircle">
                            <div class="productV2SellingLabelBodyFrequencyBodyLabelBodyCircleInner"></div>
                        </div>
                        <div class="productV2SellingLabelBodyFrequencyBodyLabelBodyTxt">
                         ${sellingPlan.name}
                        </div>
                    </div>
                </label>
            `
        });

        // insert the selling plan inputs
        section.querySelector('.productV2SellingLabelBodyFrequencyBody').innerHTML = sellingPlanInputsHTML;

        // re-attach listeners to the new inputs
        attachOptionListeners();


        /**************
         Price
         ***************/


        const compares = section.querySelectorAll(".productV2SellingLabelBodyTopPriceCompare");
        const reals = section.querySelectorAll(".productV2SellingLabelBodyTopPriceReal");

        // Destructure them for clarity:
        // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
        const [oneTimeCompare, subCompare] = compares;
        const [oneTimeReal, subReal] = reals;

        let subscriptionPrice = subscriptionVariant.selling_plan_allocations[0].price;
        let subscriptionCompare = activeVariant.price

        subscriptionPrice = 0;
        subscriptionCompare = 0;

        // compute the new prices
        section.querySelectorAll('.productV2SBundleBodyItem').forEach(element => {
            let itemData = JSON.parse(element.dataset.item);
            if (itemData) {
                subscriptionPrice += parseFloat(itemData.bundle_price.amount) * 100;
                subscriptionCompare += parseFloat(itemData.bundle_price_compare.amount) * 100;
            }
        })


        // Update subscription prices
        if (subscriptionCompare > subscriptionPrice) {
            subCompare.textContent = price(subscriptionCompare * quantity);
        }
        subReal.textContent = price(subscriptionPrice * quantity);

        // update save percent
        let savePercent = Math.round((1 - (subscriptionPrice / subscriptionCompare)) * 100);
        section.querySelector(".productV2SellingLabelBodyBottomPriceSave").textContent = ``;
        if (savePercent > 0) {
            let prefix = section.querySelector(".productV2SellingLabelBodyBottomPriceSave").dataset.prefix;
            section.querySelector(".productV2SellingLabelBodyBottomPriceSave").textContent = `${prefix} ${savePercent}%`;
        }

        // Update one-time purchase prices
        // OTP prices come from the bundle items that are available for OTP,
        // not the variant price since the bundle items may have different prices than the base product
        let totalPrice = 0;
        let totalCompare = 0;
        section.querySelectorAll('.productV2SBundleBodyItem').forEach(element => {
            let otpAvailable = JSON.parse(element.dataset.otpAvailable);
            if (otpAvailable) {
                let variant = JSON.parse(element.dataset.variant);
                if (variant) {
                    totalPrice += variant.price;
                    totalCompare += variant.compare_at_price;
                }
            }
        })

        if (totalCompare > totalPrice) {
            oneTimeCompare.textContent = price(totalCompare * quantity);
        }
        oneTimeReal.textContent = price(totalPrice * quantity);


        /**************
         BUNDLE
         ***************/

        // Update which bundle items are available based on the selling plan
        // each bundle item has a data attribute to determine if it's available for OTP
        // All bundle items are available for subscription.
        section.querySelectorAll(".productV2SBundleBodyItem").forEach(element => {
            let otpAvailable = JSON.parse(element.dataset.otpAvailable);
            if (isSubscription()) {
                element.classList.add("active");
            } else if (otpAvailable) {
                element.classList.add("active");
            } else {
                element.classList.remove("active");
            }

        })


        // update bundle item subscription titles
        section.querySelectorAll('.productV2SBundleBodyItem.sub')?.forEach(element => {
            // find the selling plan frequency
            let plan_id = currentSellingPlan();
            let plan = subscriptionProduct.selling_plan_groups[0].selling_plans.find(plan => plan.id === plan_id);
            let frequency = plan?.options[0].value || '';

            let frequencyToTxtMap = {
                "Deliver every 3 months": "Every 3 Months",
                "Deliver every 2 months": "Bi monthly",
                "Deliver every month": "Monthly"
            }

            // if subscription
            if (isSubscription()) {
                element.querySelector('.productV2SBundleBodyItemTitle').textContent = frequencyToTxtMap[frequency] || frequency;
            } else {
                element.querySelector('.productV2SBundleBodyItemTitle').textContent = 'Included';
            }
        })

        // Update gifts section title
        let giftsTitle = section.querySelector('.productV2SBundleTitle');
        if (isSubscription()) {
            giftsTitle.innerHTML = JSON.parse(giftsTitle.dataset.sub);
        } else {
            giftsTitle.innerHTML = JSON.parse(giftsTitle.dataset.otp);
        }


        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV2ATC").classList.remove('oos');
            section.querySelector(".productV2ATC").textContent = section.querySelector(".productV2ATC").dataset.available;
        } else {
            section.querySelector(".productV2ATC").classList.add('oos');
            section.querySelector(".productV2ATC").textContent = section.querySelector(".productV2ATC").dataset.sold;
        }

        /*************
         Update Sticky
         *********/

            // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }


    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productV2QuantityBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productV2QuantityBtnValue").textContent = quantity;
        updateProduct();
    });

    // plus
    section.querySelector(".productV2QuantityBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productV2QuantityBtnValue").textContent = quantity;
        updateProduct();
    });


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // OOS
        if (section.querySelector('.productV2ATC').classList.contains("oos")) {

            // Klaviyo OOS
            Swal.fire({
                title: `Notify Me When Available`,
                input: "email",
                inputPlaceholder: "Email",
                showCancelButton: true,
                confirmButtonText: "Notify Me",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    let email = Swal.getInput().value;
                    await sendKlaviyoBackInStockRequest(email, activeVariant.id);
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                // if the user confirmed the skip, show success message and reload the page
                if (result.isConfirmed) {
                    Swal.fire({
                        title: `Success`,
                        text: `We'll notify you when the product is back in stock.`,
                        icon: "success"
                    })
                }
            });
            return
        }

        // add loading animation to both buttons
        section.querySelector(".productV2ATC").classList.add("loading");


        let formData = {
            items: []
        };

        // check for subscription
        // Subscription is actually adding bundle products
        if (isSubscription()) {
            // add each item in the bundle
            section.querySelectorAll('.productV2SBundleBodyItem').forEach(item => {
                let type = JSON.parse(item.dataset.type);
                let variant = JSON.parse(item.dataset.variant);
                let itemQuantity = parseInt(item.dataset.quantity);

                if (!type || !variant) return;
                type = type[0];

                formData.items.push({
                    quantity: itemQuantity * quantity,
                    id: variant.id
                })

                // if it's a subscription purchase, add the selling plan id
                if (type === 'Subscription purchase') {
                    formData.items[formData.items.length - 1].selling_plan = currentSellingPlan();
                }
            });
        } else {
            // Add the OTP available bundle items
            section.querySelectorAll('.productV2SBundleBodyItem').forEach(item => {
                let otpAvailable = JSON.parse(item.dataset.otpAvailable);
                let variant = JSON.parse(item.dataset.variant);
                let itemQuantity = parseInt(item.dataset.quantity);

                if (otpAvailable) {
                    formData.items.push({
                        quantity: itemQuantity * quantity,
                        id: variant.id
                    })
                }
            })
        }

        // reverse formData items
        formData.items.reverse();

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV2ATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV2ATC').addEventListener("click", addToCart);


    /**************
     VIDEOS
     ***************/
    let videosExist = section.querySelector('.productV2Videos') || false;
    if (videosExist) {
        // swiper
        new Swiper(section.querySelector(".productV2Videos"), {
            slidesPerView: 2.2,
            spaceBetween: 20,
            breakpoints: {
                1210: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            }
        })

        section.querySelectorAll(".productV2VideosBtn").forEach(function (element) {
            element.addEventListener("click", function () {

                // hide play button
                this.querySelector(".productV2VideosBtnPlay").classList.add("active");

                //pause all other videos if they're playing and show their play button
                section.querySelectorAll(".productV2VideosBtn").forEach(function (other_video) {
                    if ((other_video !== element) && (!other_video.querySelector(".productV2VideosBtnVid").paused)) {
                        other_video.querySelector(".productV2VideosBtnVid").pause();
                        other_video.querySelector(".productV2VideosBtnPlay").classList.remove("active");
                    }
                });

                // if this video is paused, play it, otherwise pause it (toggles play/pause)
                if (this.querySelector(".productV2VideosBtnVid").paused) {
                    this.querySelector(".productV2VideosBtnVid").play();
                    this.querySelector(".productV2VideosBtnPlay").classList.add("active");
                } else {
                    this.querySelector(".productV2VideosBtnVid").pause();
                    this.querySelector(".productV2VideosBtnPlay").classList.remove("active");
                }
            });
        });
    }

    /**
     * Given a selling plan id, find the master selling plan object
     * @param {Object} product
     * @param {number} sellingPlanId
     * @returns {Object}
     */
    function getSellingPlanById(product, sellingPlanId) {
        let sellingPlan = null;
        product.selling_plan_groups.forEach(group => {
            group.selling_plans.forEach(plan => {
                if (plan.id === sellingPlanId) {
                    sellingPlan = plan;
                }
            });
        });
        return sellingPlan;
    }

}());